module.exports = __webpack_public_path__ + "static/media/_MIC2358.image.66735902.png";